// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep app-change-password {
   display: block;
   width: 312px;
}

.logo img {
   display: block;
   height: 44px;
   margin: 0 auto 1em;
}

.error {
   font-size: 12px;
   margin-top: 5px;
}
input {
   width: 100%;
}
label {
   display: block;
   margin-bottom: 3px;
}
.old-pass {
   margin-top: 1em;
}

.void {
   opacity: 0;
}
.dirty {
   font-size: 22px;
}
.pwd-hint {
   margin-bottom: 1em;
}

.top-error {
   margin: 1em 0;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   float:right;
}
mat-field-input{
   float:left;
   width:80%;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/change-password/change-password.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,YAAY;AACf;;AAEA;GACG,cAAc;GACd,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,eAAe;AAClB;AACA;GACG,WAAW;AACd;AACA;GACG,cAAc;GACd,kBAAkB;AACrB;AACA;GACG,eAAe;AAClB;;AAEA;GACG,UAAU;AACb;AACA;GACG,eAAe;AAClB;AACA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,WAAW;AACd;AACA;GACG,UAAU;GACV,SAAS;AACZ","sourcesContent":["::ng-deep app-change-password {\n   display: block;\n   width: 312px;\n}\n\n.logo img {\n   display: block;\n   height: 44px;\n   margin: 0 auto 1em;\n}\n\n.error {\n   font-size: 12px;\n   margin-top: 5px;\n}\ninput {\n   width: 100%;\n}\nlabel {\n   display: block;\n   margin-bottom: 3px;\n}\n.old-pass {\n   margin-top: 1em;\n}\n\n.void {\n   opacity: 0;\n}\n.dirty {\n   font-size: 22px;\n}\n.pwd-hint {\n   margin-bottom: 1em;\n}\n\n.top-error {\n   margin: 1em 0;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   float:right;\n}\nmat-field-input{\n   float:left;\n   width:80%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
